(ns iris.tags.subs
  (:require
   [re-frame.core :as re-frame]))


(re-frame/reg-sub
 ::modal
 (fn [db [_ id]]
   (get-in db [:tags :modal])))

(re-frame/reg-sub
 ::data
 (fn [db]
   (get-in db [:tags :data])))

(re-frame/reg-sub
 ::selection
 (fn [db]
   (get-in db [:tags :selection])))

(re-frame/reg-sub
 ::columns
 (fn [db [_ list]]
   (get-in db [:tags :columns list])))

(re-frame/reg-sub
 ::community-tags-api-response
 (fn [db [_]]
   (get-in db [:community-tags-api-response])))

;;;;;;;;;;;;
;; Autotags
;;;;;;;;;;;;


(re-frame/reg-sub
 ::ai-tags
 (fn [db [_ post-id source]]
   ;; get unique tags
   (let [tags (get-in db [:ai-tags post-id source] [])]
     (vec (distinct tags)))))
